import React, { useState, useEffect } from "react";
import { fetchResources } from "../Api/PayrollAttendanceservice";
import SearchableDropdown from "../Components/SearchableDropdown";
import { useAuth } from "../Context/AuthContext";
import "../Styling/PayrollTheme.css";

const PayrollAttendanceControls = ({
  filters,
  setFilters,
  months,
  hideStatus,
}) => {
  const { user } = useAuth();
  const orgId = user?.organisationId;
  const [resources, setResources] = useState([]);

  useEffect(() => {
    if (!orgId) return;
    fetchResources(orgId)
      .then((res) => {
        const cleaned = res.map((r) => ({
          resourceId: r.resourceId?.trim(),
          resourceName: r.resourceName?.trim(),
        }));
        setResources(cleaned);
      })
      .catch(() => setResources([]));
  }, [orgId]);

  const gridClass = `pac-controls__grid ${
    hideStatus ? "pac-controls__grid--nstatus" : "pac-controls__grid--full"
  }`;

  return (
    <div className="pac-controls__card">
      <div className="pac-controls__section-label">Filters</div>

      <div className={gridClass}>
        {/* Month */}
        <div className="pac-controls__field">
          <label className="pac-controls__label">Month</label>
          <select
            className="pac-controls__select"
            value={filters.workingDaysId || ""}
            onChange={(e) =>
              setFilters({ ...filters, workingDaysId: e.target.value, page: 1 })
            }
          >
            <option value="">Select</option>
            {months.map((m) => (
              <option key={m.workingDaysId} value={m.workingDaysId}>
                {m.label}
              </option>
            ))}
          </select>
        </div>

        {/* Name */}
        <div className="pac-controls__field">
          <label className="pac-controls__label">Name</label>
          <input
            type="text"
            className="pac-controls__input"
            placeholder="Search name…"
            onChange={(e) =>
              setFilters({ ...filters, resourceName: e.target.value, page: 1 })
            }
          />
        </div>

        {/* Resource (searchable) */}
        <div className="pac-controls__field">
<SearchableDropdown
  label="Resource"
  options={resources}
  value={filters.resourceId || ""}
  onChange={(e) =>
    setFilters((prev) => ({
      ...prev,
      resourceId: e?.target?.value || "",   
      page: 1,
    }))
  }
/>
        </div>

        {/* Status — hidden for Leaves view */}
        {!hideStatus && (
          <div className="pac-controls__field">
            <label className="pac-controls__label">Status</label>
            <select
              className="pac-controls__select"
              onChange={(e) =>
                setFilters({ ...filters, status: e.target.value, page: 1 })
              }
            >
              <option value="">All</option>
              <option value="Present">Present</option>
              <option value="Absent">Absent</option>
              <option value="Leave">Leave</option>
              <option value="WeekOff">Week Off</option>
              <option value="Holiday">Holiday</option>
              <option value="Half Day">Half Day</option>
            </select>
          </div>
        )}

        {/* From Date */}
        <div className="pac-controls__field">
          <label className="pac-controls__label">From</label>
          <input
            type="date"
            className="pac-controls__input"
            onChange={(e) =>
              setFilters({ ...filters, fromDate: e.target.value, page: 1 })
            }
          />
        </div>

        {/* To Date */}
        <div className="pac-controls__field">
          <label className="pac-controls__label">To</label>
          <input
            type="date"
            className="pac-controls__input"
            onChange={(e) =>
              setFilters({ ...filters, toDate: e.target.value, page: 1 })
            }
          />
        </div>
      </div>
    </div>
  );
};

export default PayrollAttendanceControls;
